import { axios } from '@/services/axios';

const getAllLocations = async () => {
    const res = await axios.get('/trunklocations/');
    return res.data;
};

export default getAllLocations;
